import { render, staticRenderFns } from "./ConfigTest.vue?vue&type=template&id=64facebc&scoped=true"
import script from "./ConfigTest.vue?vue&type=script&lang=js"
export * from "./ConfigTest.vue?vue&type=script&lang=js"
import style0 from "./ConfigTest.vue?vue&type=style&index=0&id=64facebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64facebc",
  null
  
)

export default component.exports